export default "__VITE_ASSET__BgiFMnP2__"